module.exports = __webpack_public_path__ + "static/img/iconmenu06.379b7ce7.svg";